exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-append .input-group-text[data-v-55855dda] {\n  height: calc(1.6em + 0.75rem + 2px);\n}", ""]);

// exports
